// Initial state
const initialState = {
  available: [] as string[],
  subscribed: [] as string[],
  loading: false,
  error: null as string | null,
};

// Action types
const FETCH_MAILING_LISTS = 'FETCH_MAILING_LISTS';
const SUBSCRIBE_TO_LIST = 'SUBSCRIBE_TO_LIST';
const UNSUBSCRIBE_FROM_LIST = 'UNSUBSCRIBE_FROM_LIST';

// Reducer with logging
export default function mailingListsReducer(state = initialState, action: any) {
  switch (action.type) {
    case `${FETCH_MAILING_LISTS}_REQUEST`:
      console.log('Fetching mailing lists started');
      return { ...state, loading: true, error: null };

    case `${FETCH_MAILING_LISTS}_SUCCESS`:
      console.log('Fetching mailing lists succeeded:', action.result);
      return {
        ...state,
        loading: false,
        available: action.result.available,
        subscribed: action.result.subscribed,
      };

    case `${FETCH_MAILING_LISTS}_FAILURE`:
      console.error('Fetching mailing lists failed:', action.error);
      return { ...state, loading: false, error: action.error };

    case `${SUBSCRIBE_TO_LIST}_SUCCESS`:
      console.log(`Subscribed to list: ${action.listName}`);
      return {
        ...state,
        loading: false,
        subscribed: action.payload.subscribed,
      };

    case `${SUBSCRIBE_TO_LIST}_FAILURE`:
      console.error('Subscribe failed:', action.error);
      return { ...state, loading: false, error: action.error };

    case `${UNSUBSCRIBE_FROM_LIST}_SUCCESS`:
      console.log(`Unsubscribed from list: ${action.listName}`);
      return {
        ...state,
        loading: false,
        subscribed: action.payload.subscribed,
      };

    case `${UNSUBSCRIBE_FROM_LIST}_FAILURE`:
      console.error('Unsubscribe failed:', action.error);
      return { ...state, loading: false, error: action.error };

    default:
      return state;
  }
}

// Action creators

export function fetchMailingLists() {
  console.log('Dispatching fetchMailingLists action');
  return {
    type: FETCH_MAILING_LISTS,
    request: {
      op: 'get',
      path: '/@mailinglists/getSettings',
    },
  };
}

export function subscribeToList(listName: string) {
  console.log('Dispatching subscribe action for:', listName);
  return (dispatch: any, getState: any) => {
    const state = getState();
    const currentSubscribed = state.mailingLists.subscribed;
    const newSubscribed = [...currentSubscribed, listName];

    // Update YOUR mailing lists reducer
    dispatch({
      type: `${SUBSCRIBE_TO_LIST}_SUCCESS`,
      listName,
      payload: {
        subscribed: newSubscribed,
      },
    });
  };
}

export function unsubscribeFromList(listName: string) {
  console.log('Dispatching unsubscribe action for:', listName);
  return (dispatch: any, getState: any) => {
    const state = getState();
    const currentSubscribed = state.mailingLists.subscribed;
    const newSubscribed = currentSubscribed.filter((name) => name !== listName);

    // Update YOUR mailing lists reducer
    dispatch({
      type: `${UNSUBSCRIBE_FROM_LIST}_SUCCESS`,
      listName,
      payload: {
        subscribed: newSubscribed,
      },
    });

  };
}

